import { render, staticRenderFns } from "./ModelCart.vue?vue&type=template&id=23c0e00e&"
import script from "./ModelCart.vue?vue&type=script&lang=js&"
export * from "./ModelCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports